import axios from "axios";
import ApiUrl from "~/utils/RewriteApi";
import { getBannerStart, getBannerSuccess, getBannerFailed } from "~/redux/slice/BannerSlice";

export const getBanner = async (dispath) => {
  dispath(getBannerStart());
  try {
    const res = await axios.get(ApiUrl(`/banner/get-banner`));
    dispath(getBannerSuccess(res.data.listBanner));
  } catch (error) {
    dispath(getBannerFailed());
    console.log(error);
  }
};
